var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-tab", {
        attrs: {
          type: "horizon",
          dense: true,
          tabItems: _vm.tabItems,
          inlineLabel: true,
          height: _vm.tabHeight,
        },
        on: {
          "update:tabItems": function ($event) {
            _vm.tabItems = $event
          },
          "update:tab-items": function ($event) {
            _vm.tabItems = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tab) {
              return [
                _c(tab.component, {
                  tag: "component",
                  attrs: {
                    popupParam: _vm.popupParam,
                    traningEdu: _vm.traningEdu,
                    attachTeachingMaterialsInfo:
                      _vm.attachTeachingMaterialsInfo,
                    attachTrainingPictureInfo: _vm.attachTrainingPictureInfo,
                    attachEduPictureInfo: _vm.attachEduPictureInfo,
                    isOld: _vm.isOld,
                    contentHeight: _vm.contentHeight,
                  },
                  on: {
                    "update:popupParam": function ($event) {
                      _vm.popupParam = $event
                    },
                    "update:popup-param": function ($event) {
                      _vm.popupParam = $event
                    },
                    "update:traningEdu": function ($event) {
                      _vm.traningEdu = $event
                    },
                    "update:traning-edu": function ($event) {
                      _vm.traningEdu = $event
                    },
                    "update:attachTeachingMaterialsInfo": function ($event) {
                      _vm.attachTeachingMaterialsInfo = $event
                    },
                    "update:attach-teaching-materials-info": function ($event) {
                      _vm.attachTeachingMaterialsInfo = $event
                    },
                    "update:attachTrainingPictureInfo": function ($event) {
                      _vm.attachTrainingPictureInfo = $event
                    },
                    "update:attach-training-picture-info": function ($event) {
                      _vm.attachTrainingPictureInfo = $event
                    },
                    "update:attachEduPictureInfo": function ($event) {
                      _vm.attachEduPictureInfo = $event
                    },
                    "update:attach-edu-picture-info": function ($event) {
                      _vm.attachEduPictureInfo = $event
                    },
                    "update:contentHeight": function ($event) {
                      _vm.contentHeight = $event
                    },
                    "update:content-height": function ($event) {
                      _vm.contentHeight = $event
                    },
                    getDetail: _vm.getDetail,
                    closePopup: _vm.closePopup,
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.tab,
          callback: function ($$v) {
            _vm.tab = $$v
          },
          expression: "tab",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }